"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var VideoStreamDescription = /*#__PURE__*/function () {
  function VideoStreamDescription(attendeeId, groupId, streamId, maxBitrateKbps, avgBitrateKbps) {
    _classCallCheck(this, VideoStreamDescription);

    this.attendeeId = '';
    this.groupId = 0;
    this.streamId = 0;
    this.ssrc = 0;
    this.trackLabel = '';
    this.maxBitrateKbps = 0; // average bitrate is updated every 2 seconds via bitrates messages

    this.avgBitrateKbps = 0;
    this.maxFrameRate = 0;
    this.timeEnabled = 0;
    this.disabledByWebRTC = false;
    this.disabledByUplinkPolicy = false;
    this.attendeeId = attendeeId;
    this.groupId = groupId;
    this.streamId = streamId;
    this.maxBitrateKbps = maxBitrateKbps;
    this.avgBitrateKbps = avgBitrateKbps;
  }

  _createClass(VideoStreamDescription, [{
    key: "clone",
    value: function clone() {
      var newInfo = new VideoStreamDescription();
      newInfo.attendeeId = this.attendeeId;
      newInfo.groupId = this.groupId;
      newInfo.streamId = this.streamId;
      newInfo.ssrc = this.ssrc;
      newInfo.trackLabel = this.trackLabel;
      newInfo.maxBitrateKbps = this.maxBitrateKbps;
      newInfo.avgBitrateKbps = this.avgBitrateKbps;
      newInfo.maxFrameRate = this.maxFrameRate;
      newInfo.timeEnabled = this.timeEnabled;
      newInfo.disabledByWebRTC = this.disabledByWebRTC;
      newInfo.disabledByUplinkPolicy = this.disabledByUplinkPolicy;
      return newInfo;
    }
  }, {
    key: "toStreamDescriptor",
    value: function toStreamDescriptor() {
      var descriptor = SignalingProtocol_js_1.SdkStreamDescriptor.create();
      descriptor.mediaType = SignalingProtocol_js_1.SdkStreamMediaType.VIDEO;
      descriptor.trackLabel = this.trackLabel;
      descriptor.attendeeId = this.attendeeId;
      descriptor.streamId = this.streamId;
      descriptor.groupId = this.groupId;
      descriptor.framerate = this.maxFrameRate;
      descriptor.maxBitrateKbps = this.disabledByUplinkPolicy || this.disabledByWebRTC ? 0 : this.maxBitrateKbps;
      descriptor.avgBitrateBps = this.avgBitrateKbps;
      return descriptor;
    }
  }]);

  return VideoStreamDescription;
}();

exports.default = VideoStreamDescription;